import React from 'react';
import WorklogCard from '../WorklogCard';
import WorklogRow from '../WorklogRow';
import TableHeader from '../TableHeader';

const UngroupedView = ({ worklogs, headerControls }) => {
  return (
    <div className="bg-white dark:bg-slate-800 rounded-lg shadow-sm overflow-hidden">
      <div className="px-4 py-3 border-b border-gray-200 dark:border-white/10">
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-3">
          <h3 className="text-lg font-medium text-gray-900 dark:text-slate-100 min-w-0">
            Worklog Entries ({worklogs.length})
          </h3>
          <div className="min-w-0 flex-shrink">
            {headerControls}
          </div>
        </div>
      </div>
      
      {/* Mobile: Card View */}
      <div className="md:hidden p-4 space-y-4">
        {worklogs.map(log => (
          <WorklogCard key={log.id} log={log} />
        ))}
      </div>

      {/* Desktop: Table View */}
      <div className="hidden md:block overflow-x-auto -mx-4 sm:mx-0">
        <div className="inline-block min-w-full align-middle">
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200 dark:divide-white/10">
              <TableHeader />
              <tbody className="bg-white dark:bg-slate-800 divide-y divide-gray-200 dark:divide-white/10">
                {worklogs.map(log => (
                  <WorklogRow key={log.id} log={log} />
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UngroupedView;

